const looksLikeDateOnly = (v) => typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v);

export const mapItems = (data) =>
    (Array.isArray(data) ? data : []).map((it) => {
        const tipo = (it.tipo || "GEN").toUpperCase();
        const subTipoCaceria = (it.titulo || "").toLowerCase();
        const titulo = it.titulo || "";
        const parentId = it.eventoId || null;

        let start = it.start;
        let end = it.end;

        const isAllDay = it.allDay ?? true;

        // FullCalendar: end exclusive para allDay
        if (isAllDay && end && looksLikeDateOnly(start) && looksLikeDateOnly(end)) {
            if (start !== end) {
                const d = new Date(end);
                d.setDate(d.getDate() + 1);
                end = d.toISOString().split("T")[0];
            } else {
                end = undefined;
            }
        }

        return {
            id: `${tipo}-${it.id}`,
            title: titulo,
            start,
            end,
            allDay: isAllDay,
            extendedProps: {
                tipo,
                subTipoCaceria,
                parentId,
                esProvisional: it.esProvisional ?? false,
            },
        };
    });
